var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ny-default",attrs:{"id":"app"}},[_c('navView',{attrs:{"count":_vm.count}}),_c('router-view',{on:{"childVal":_vm.parentVal}}),_c('footerView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }